import * as yup from 'yup'

import validations from 'constants/validations'

const { STRING_SCHEMA_TYPE } = validations

const equalsSibling = {
  name: 'equalsSibling',
  schemaType: STRING_SCHEMA_TYPE,
  method(field, message = 'Os valores devem ser iguais.') {
    return this.oneOf([yup.ref(field), null], message)
  },
}

export default equalsSibling
